import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../hooks';
import { AvailabilityResponse, CareModel, MeetingTypeId } from '../types';
import qs from 'qs';

export const useCoachAvailability = ({
  care_model,
  coach_uuid,
  end_date,
  start_date,
  timezone,
}: {
  care_model?: CareModel;
  coach_uuid?: string;
  end_date?: string;
  start_date?: string;
  timezone?: string;
}) => {
  const { api } = useApi();

  const fetchAvailability = async (): Promise<AvailabilityResponse> => {
    const queryStr = qs.stringify({
      appt_type: MeetingTypeId.InitialCoachCall,
      end_date,
      start_date,
      timezone,
    });

    return api({
      route: `/coach/${coach_uuid}/availability${
        queryStr ? `?${queryStr}` : ''
      }`,
    });
  };

  const { data, isInitialLoading, isLoading, isError } = useQuery<
    AvailabilityResponse,
    Error
  >({
    queryKey: ['public-coach-availability', start_date, end_date],
    queryFn: fetchAvailability,
    enabled: !!coach_uuid && !!timezone && care_model === CareModel.CoachOnly,
    refetchOnWindowFocus: false,
  });

  return {
    isLoading: isInitialLoading || isLoading,
    isError,
    data,
  };
};
